import { Component, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { MaterialModulesModule } from '../../material-modules/material-modules.module';
import { MatSidenav } from '@angular/material/sidenav';
import { AnimationPlayer } from '@angular/animations';
import { CommonUtilityService } from '../../utility/common-utility.service';
import { SharedService } from '../../shared.service';
import { BreakpointObserver } from '@angular/cdk/layout';
import { CustomThemeService } from '../../utility/custom-theme.service';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from '../header/header.component';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrl: './menu.component.scss',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports:[
      MaterialModulesModule,
      CommonModule,
      HeaderComponent,
      RouterModule
    ]
})
export class MenuComponent implements OnInit {
  activeIndex;
  player: AnimationPlayer;
  isMouseInside = false;
  isSidenavOpen = true;
  logoPath$ = this.customThemeService.logoPath$;
  smallLogoPath$ = this.customThemeService.smallLogoPath$;
  isDefaultLogo = false;
  isDefaultSmallLogo = false;

  ngOnInit(): void {
    const savedState = localStorage.getItem('SIDEMENU_STATE');
    this.isShowing = savedState !== null ? JSON.parse(savedState) : true;
    this.sideMenuOpened = this.isShowing;
  
    this.breakpointObserver
      .observe(['(min-width: 1024px) and (max-width: 1200px)'])
      .subscribe(result => {
        if (result.matches) {
          // collapse all by default
          this.isShowing = false;
          this.sideMenuOpened = false;
        } else {
          this.isShowing = savedState !== null ? JSON.parse(savedState) : true;
          this.sideMenuOpened = this.isShowing;
        }
  
        this.commonUtilityService.changesideMenuOpened(this.isShowing);
      });
    this.setActivePage();
  }

  onMainLogoLoad(event: any) {
    const src = event.target.src;
  
    this.isDefaultLogo =
      src.includes('yokahu-logo-black.svg');
  }

  onSmallLogoLoad(event: any) {
    const src = event.target.src;
  
    this.isDefaultSmallLogo =
      src.includes('/assets/images/yokahu-logo-only.png');
  }

  onImgError(event: Event) {
    // const img = event.target as HTMLImageElement;
    // setTimeout(() => {
    //   img.src = '/assets/images/yokahu-logo-black.svg';
    //   this.isDefaultLogo = true;
    // }, 4000); 
  }
  
  onSmallImgError(event: Event) {
    // const img = event.target as HTMLImageElement;
    // setTimeout(() => {
    //   img.src = '/assets/images/yokahu-logo-only.png';
    //   this.isDefaultSmallLogo = true;
    // }, 4000);
  }  

  get getActiveIndex() {
    this.setActivePage();
    return this.activeIndex;
  }
  setActivePage() {
    this.activeIndex = null;
    let page = localStorage.getItem('page');
    if (!this.router.url.includes('home')) {
      if (this.router.url == '/new-request' || this.router.url == '/set-location' || this.router.url == '/edit-request' || this.router.url == '/create-version') {
        this.activeIndex = 2;
      } else if (this.router.url == '/search' && page == 'requests' || this.router.url == '/non-binding-indication'
        || this.router.url == '/match-structure' || this.router.url == '/historic-events') {
        this.activeIndex = 3;
      } else if (this.router.url == '/search' && page == 'non-binding-indication') {
        this.activeIndex = 4;
      } else if (this.router.url == '/search' && page == 'firm-quote') {
        this.activeIndex = 5;
      } else if (this.router.url == '/search' && page == 'bind') {
        this.activeIndex = 6;
      } else if (this.router.url == '/search' && page == 'quote-request') {
        this.activeIndex = 8;
      } else if (this.router.url == '/search' && page == 'underWriting') {
        this.activeIndex = 9;
      } else if (this.router.url == '/search') {
        this.activeIndex = 1;
      } else if (this.router.url == '/clients') {
        this.activeIndex = 7;
      }
    }
  }

  constructor(public router: Router, private commonUtilityService: CommonUtilityService,
    private sharedService: SharedService, private breakpointObserver: BreakpointObserver,
    private customThemeService: CustomThemeService
  ) { }

  @ViewChild('sidenav') sidenav: MatSidenav;
  isExpanded = true;
  @Input() searchFilterOpened: boolean = true
  @Input() sideMenuOpened: boolean = true
  showSubmenu: boolean = false;
  isShowing = true;
  showSubSubMenu: boolean = false;

  openclose(data) {
    this.isShowing = !this.isShowing;
    this.sideMenuOpened = !this.sideMenuOpened;
    localStorage.setItem('SIDEMENU_STATE', JSON.stringify(this.isShowing));
    this.commonUtilityService.changesideMenuOpened(this.sideMenuOpened);
  }

  filterToggle(event) {
    this.searchFilterOpened = event
  }

  isClickInsideSidenav(event: MouseEvent): boolean | any {
    const sidenavElement = document.getElementById('side-nav-menu');
    return sidenavElement && sidenavElement.contains(event.target as Node);
  }

  onButtonGroupClick($event: MouseEvent): void {
    let clickedElement = ($event.target || $event.srcElement) as HTMLElement;

    if (clickedElement.nodeName === "SPAN") {
      let isCertainButtonAlreadyActive = clickedElement.parentElement?.querySelector(".active") as HTMLElement | null;
      if (isCertainButtonAlreadyActive) {
        isCertainButtonAlreadyActive.classList.remove("active");
      }

      clickedElement.className += " active";
    }
  }

  search(activeIndex) {
    localStorage.removeItem('page');
    localStorage.removeItem('search_id');
    this.activeIndex = activeIndex;
    if (this.router.url == '/search') {
      location.reload();
    } else {
      this.router.navigate(['/search'])
    }
  }

  newRequest(activeIndex) {
    this.router.navigate(['/new-request']);
    localStorage.removeItem('search_id');
    this.activeIndex = activeIndex;
  }

  nonBindingIndication(activeIndex) {
    localStorage.removeItem('selectedRequest');
    localStorage.removeItem('selectedLocation');
    localStorage.removeItem('structure');
    localStorage.removeItem('insurable_interest_id');
    this.activeIndex = activeIndex;
    this.setSearchParams('non-binding-indication');
  }

  quote(activeIndex) {
    this.activeIndex = activeIndex;
    this.setSearchParams('firm-quote');
  }

  bind(activeIndex) {
    this.activeIndex = activeIndex;
    this.setSearchParams('bind');
  }

  requests(activeIndex) {
    this.activeIndex = activeIndex;
    this.setSearchParams('requests');
    this.sharedService.removeValueFromLocalStorage()
  }

  setSearchParams(page: any) {
    localStorage.removeItem('search_id');
    localStorage.setItem('page', page);
    if (this.router.url == '/search') {
      location.reload();
    }
    this.router.navigate(['search']);
  }

  clients(activeIndex: any) {
    this.activeIndex = activeIndex;
    this.router.navigate(['/clients']);
  }

  quoteRequested(activeIndex: any) {
    this.activeIndex = activeIndex;
    this.setSearchParams('quote-request');
  }

  underwriting(activeIndex: any) {
    this.activeIndex = activeIndex;
    this.setSearchParams('underWriting');
  }

}
